/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Class that defines the basic properties of a operation
 */
export type OperationBaseDTO = {
    /**
     * Indicates the name of the user who initiated the operation
     */
    collectedBy?: string;
    /**
     * Creation date
     */
    createdAt?: string;
    /**
     * Currency of the operation
     */
    currency?: string;
    /**
     * Id of this operation
     */
    operationId?: string;
    /**
     * Indicates if the money is flowing IN or OUT of the merchant account
     */
    operationType?: OperationBaseDTO.operationType;
    /**
     * Payment method of the operation
     */
    paymentMethod?: OperationBaseDTO.paymentMethod;
    /**
     * Indicates the sessionId of the transaction
     */
    sessionId?: string;
    /**
     * Indicates the status of the operation
     */
    status?: OperationBaseDTO.status;
    /**
     * Indicates the total amount of the operation (includes fee)
     */
    totalAmount?: number;
    /**
     * Indicates the transaction id saved in external service
     */
    transactionId?: string;
    /**
     * Indicates the virtual account number the transaction was paid to
     */
    transferAccount?: string;
};

export namespace OperationBaseDTO {

    /**
     * Indicates if the money is flowing IN or OUT of the merchant account
     */
    export enum operationType {
        IN = 'IN',
        OUT = 'OUT',
    }

    /**
     * Payment method of the operation
     */
    export enum paymentMethod {
        CASH = 'CASH',
        POS = 'POS',
        USSD = 'USSD',
        QR_CODE = 'QR_CODE',
        IN_BANK_TRANSFER = 'IN_BANK_TRANSFER',
        INWARDS_TRANSFER = 'INWARDS_TRANSFER',
        PAY_WITH_TRANSFER = 'PAY_WITH_TRANSFER',
        MOMO = 'MOMO',
        PAYMENT_LINK = 'PAYMENT_LINK',
        OUT_BANK_TRANSFER = 'OUT_BANK_TRANSFER',
        REFUND = 'REFUND',
        CARD = 'CARD',
    }

    /**
     * Indicates the status of the operation
     */
    export enum status {
        SUCCESS = 'SUCCESS',
        EXPIRED = 'EXPIRED',
        PENDING = 'PENDING',
        DECLINED = 'DECLINED',
        FAILED = 'FAILED',
    }


}
